import script from "./RoamingSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoamingSearch.vue?vue&type=script&setup=true&lang=ts"

import "./RoamingSearch.vue?vue&type=style&index=0&id=dedbf278&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dedbf278"]])

export default __exports__